let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("73ZL4")).then(() => parcelRequire('el8fJ'));